import React, { Component } from 'react';

export class PageSection extends Component {
    render() {
        return (
            <div id={this.props.sectionId} className="page-section">
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/PageSection.jsx